module.exports = __webpack_public_path__ + "img/booking-pc.9ca4c54c.png";